function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getBasePathname = function getBasePathname() {
  if (process.env.BASE_URL.startsWith('/')) {
    return process.env.BASE_URL.substr(1);
  }

  return process.env.BASE_URL;
};

var getLangFromPathname = function getLangFromPathname(pathname) {
  var defaultLang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.env.LANG_DEFAULT;
  var parts = pathname.split('/').filter(Boolean);

  if (parts.indexOf(getBasePathname()) === 1) {
    return parts[0];
  }

  return defaultLang;
};

var setLangToPathname = function setLangToPathname(pathname) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.env.LANG_DEFAULT;

  if (!pathname) {
    return pathname;
  }

  var parts = pathname.split('/').filter(Boolean);
  var langFromPathname = getLangFromPathname(pathname, null);
  var pathnameWithoutLang = pathname;

  if (langFromPathname) {
    var partsWithoutLang = _toConsumableArray(parts);

    partsWithoutLang.splice(0, 1);
    pathnameWithoutLang = "/".concat(partsWithoutLang.join('/'));
  }

  if (lang === process.env.LANG_DEFAULT) {
    return pathnameWithoutLang;
  }

  return "/".concat(lang).concat(pathnameWithoutLang);
};

var setBasenameToPathname = function setBasenameToPathname(pathname) {
  if (!pathname) {
    return pathname;
  }

  var langFromPathname = getLangFromPathname(pathname, null);
  var parts = pathname.split('/').filter(Boolean);

  if (!langFromPathname && parts[0] === getBasePathname() || langFromPathname && parts[1] === getBasePathname()) {
    return pathname;
  }

  return process.env.BASE_URL + pathname;
};

var buildPathname = function buildPathname(pathname, lang) {
  if (!pathname) {
    return pathname;
  }

  return setLangToPathname(setBasenameToPathname(pathname), lang);
};

var buildLinkTo = function buildLinkTo(to, lang) {
  if (typeof to === 'string') {
    return buildPathname(to, lang);
  }

  if (_typeof(to) === 'object' && 'pathname' in to) {
    return _objectSpread(_objectSpread({}, to), {}, {
      pathname: buildPathname(to.pathname, lang)
    });
  }

  return to;
};

var setLangToLocationDescriptor = function setLangToLocationDescriptor(locationDescriptor, lang) {
  var locationDescriptorNew;

  if (typeof locationDescriptor === 'string') {
    locationDescriptorNew = buildPathname(locationDescriptor, lang);
  } else {
    locationDescriptorNew = _objectSpread({}, locationDescriptor);

    if ('pathname' in locationDescriptorNew) {
      locationDescriptorNew.pathname = buildPathname(locationDescriptor.pathname, lang);
    }
  }

  return locationDescriptorNew;
};

export { getLangFromPathname, setLangToPathname, setBasenameToPathname, buildPathname, buildLinkTo, setLangToLocationDescriptor };